<template>
  <div class="input-group condition">
    <select v-model="condition.variable">
      <option v-for="v in variables" :key="v" :value="v">{{ v }}</option>
    </select>
    <select v-model="condition.operator">
      <option value="==">==</option>
      <option value="!=">!=</option>
      <option value="<">&lt;</option>
      <option value=">">&gt;</option>
      <option value="<=">&lt;=</option>
      <option value=">=">&gt;=</option>
      <option value="in">in</option>
      <option value="not in">not in</option>
    </select>
    <input
      v-model="condition.value"
      placeholder="value or array for in/not in"
    />
  </div>
</template>

<script>
export default {
  props: ["variables", "modelValue"],
  computed: {
    condition: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
